<script>
export default {
  props: {
    user: {
      default: null,
      type: Object,
    },
  },
  beforeMount() {
    if (this.user) {
      this.$store.commit('setSession', this.user);
    } else {
      this.$store.commit('setSession', null);
    }
  },

  render() {
    return null;
  },
};
</script>
